module.exports = __webpack_public_path__ + "img/eye.e4fe315c.svg";